import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import Page from '../../components/Page';
import { SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));

function buildQuery(params) {
  const q = new URLSearchParams();
  Object.keys(params).forEach(key => {
    const v = params[key];
    if (v !== undefined && v !== null && v !== '') {
      q.set(key, String(v));
    }
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const StallBookings = withRouter(() => {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [totalcount, setTotalcount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchText, setSearchText] = useState('');
  const { sendNetworkRequest } = React.useContext(NetworkContext);

  useEffect(() => {
    async function load() {
      const limit = Math.min(rowsPerPage, 100);
      const apiPage = page + 1;
      const query = buildQuery({
        page: apiPage,
        limit,
        searchtext: searchText || undefined
      });
      const response = await sendNetworkRequest(
        `/admin/exhibitor-stall-requests${query}`,
        {},
        undefined
      );
      if (!response || !Array.isArray(response.exhibitorStallRequests)) {
        setRows([]);
        setTotalcount(0);
        return;
      }
      setTotalcount(typeof response.total === 'number' ? response.total : 0);
      setRows(response.exhibitorStallRequests);
    }
    load();
  }, [page, rowsPerPage, searchText]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }

  function handleRowsPerPageChange(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  function applySearch(searchcontent) {
    setPage(0);
    setSearchText(searchcontent || '');
  }

  return (
    <Page className={classes.root} title="Stall Bookings">
      <Header />
      <SearchBar onSearch={applySearch} />
      <Results
        className={classes.results}
        rows={rows}
        totalcount={totalcount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onPageLimit={handleRowsPerPageChange}
      />
    </Page>
  );
});

export default StallBookings;
